import type { RegisteredServices } from '@/core/container/types'

export type ReportingEmailOverviewBlockType =
  | 'totalSent'
  | 'delivered'
  | 'bounced'
  | 'suppressed'
  | 'uniqueRecipients'
  | 'deliveryRate'
  | 'bounceRate'
  | 'suppressRate'
  | 'opened'
  | 'clicked'
  | 'unsubscribed'
  | 'spamReports'
  | 'openRate'
  | 'clickRate'
  | 'unsubscribeRate'
  | 'spamRate'

export type ReportingEmailOverviewBlock = {
  count: number
  change: number
  isUp: boolean
}
export type ReportingEmailOverviewBlocks = Record<ReportingEmailOverviewBlockType, ReportingEmailOverviewBlock>

export const reportingEmailEngagementBreakdownTypes = [
  'opened',
  'clicked',
  'unsubscribed',
  'spam',
  'noInteraction',
] as const
export type ReportingEmailEngagementBreakdownType = (typeof reportingEmailEngagementBreakdownTypes)[number]
export type ReportingEmailEngagementBreakdownChart = Record<ReportingEmailEngagementBreakdownType, number>

export type ReportingEmailBounceReasonType =
  | 'recipient_has_no_email'
  | 'recipient_has_invalid_email'
  | 'recipient_is_unsubscribed'
  | 'recipient_is_role_address'
  | 'recipient_domain_is_blacklisted'
  | 'recipient_has_typo_in_domain'
  | 'attachment_type_forbidden'
  | 'inactive_recipient'
  | 'hard_bounce'
  | 'transient'
  | 'unsubscribe'
  | 'subscribe'
  | 'auto_responder'
  | 'address_change'
  | 'dns_error'
  | 'spam_notification'
  | 'open_relay_test'
  | 'unknown'
  | 'soft_bounce'
  | 'virus_notification'
  | 'challenge_verification'
  | 'bad_email_address'
  | 'spam_complaint'
  | 'manually_deactivated'
  | 'unconfirmed'
  | 'blocked'
  | 'smtp_api_error'
  | 'inbound_error'
  | 'dmarc_policy'
  | 'template_rendering_failed'

export type ReportingEmailBounceReason = {
  reason: ReportingEmailBounceReasonType
  count: number
  share: number
}
export type ReportingEmailBounceReasonsChart = {
  items: ReportingEmailBounceReason[]
}

export type ReportingEmailOverviewCharts = {
  engagementBreakdown: ReportingEmailEngagementBreakdownChart
  bounceReasons: ReportingEmailBounceReasonsChart
}

export type ReportingEmailTrendRow = {
  date: string
  sent: number
  deliveryRate: number
  openRate: number
  clickRate: number
  bounceRate: number
  unsubscribeRate: number
  spamRate: number
  costs: number
}

export type ReportingEmailTrendsResponse = {
  items: ReportingEmailTrendRow[]
  isPreview: boolean
}

export type ReportingEmailTrendsFilter = {
  userId?: string
  groupBy?: 'year' | 'month' | 'day'
  year?: number
  month?: number
}

export const ReportingEmailTrendsTableId = 'reportingEmailTrendsTableId' as RegisteredServices

export const ReportingEmailSendersTableId = 'reportingEmailSendersTableId' as RegisteredServices

export const ReportingEmailLinksTableId = 'reportingEmailLinksTableId' as RegisteredServices

export const ReportingEmailUsersTableId = 'reportingEmailUsersTableId' as RegisteredServices

export const reportingEmailTrendsChartTypes = [
  'sent',
  'deliveryRate',
  'openRate',
  'clickRate',
  'bounceRate',
  'unsubscribeRate',
  'spamRate',
  'costs',
] as const

export type ReportingEmailTrendsChartType = (typeof reportingEmailTrendsChartTypes)[number]
